import { actionsStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderActions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

actionsStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-flow: column;
                `,
                css`
                    flex-flow: column;
                `,
                null,
                null,
                null,
            ])}
    `,
};

actionsStyles.buttonsHidden = {
    css: css`
        display: flex;
    `,
};

actionsStyles.uploadOrderButton = {
    variant: "secondary",
    css: css`
        @media (min-width: 768px) and (max-width: 850px) {
            padding: 0 10px;
        }
    `,
};

actionsStyles.addToListButton = {
    variant: "tertiary",
    css: css`
        @media (min-width: 768px) and (max-width: 850px) {
            padding: 0 10px;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 10px;
                `,
                css`
                    margin-top: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
            ])}
    `,
};
actionsStyles.addAllToCartButton = {
    variant: "primary",
    css: css`
        @media (min-width: 768px) and (max-width: 850px) {
            padding: 0 10px;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 10px;
                `,
                css`
                    margin-top: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
            ])}
    `,
};
